import React from 'react'

export default function Empty() {
  return (
    <section className="performance-table__empty">
      <h2>Start by selecting a strategy or category</h2>
    </section>
  )
}



// WEBPACK FOOTER //
// ./src/components/strategies/historical/empty.js